// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__sIEad","social":"socials__social___At_b","icon":"socials__icon__Uvr1v","navOpen":"socials__navOpen__CrLoe"};